export const ADDRESS_ZERO = "0x0000000000000000000000000000000000000000"
export const PRE_CONTRACT_ADDRESS_ROPSTEN =
  "0xb6f98dA65174CE8F50eA0ea4350D96B2d3eFde9a"
export const PRE_CONTRACT_ADDRESS_MAINNET =
  "0x7E01c9c03FD3737294dbD7630a34845B0F70E5Dd"
